import { defaultTransitionConfig } from "@app/configs/animation";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Layout = styled.div`
  z-index: 10001;
  position: fixed;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  overflow: hidden;
  top: 10px;
  left: 20px;
  right: 20px;
  pointer-events: none;
  padding: var(--spacing-s) 0;
`;

const Container = styled(motion.div)`
  width: auto;
  max-width: 100%;
  background: rgba(20, 20, 20, 0.92);
  color: #fff;
  border-radius: var(--border-radius-m);
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-s) var(--spacing-m);
  font: var(--font-m);
  padding-bottom: var(--spacing-xs);
  line-height: 1.2;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  pointer-events: auto;

  p {
    margin: 0;
    color: #fff;
  }

  span {
    font: var(--font-s);
    font-style: italic;
    color: rgba(255, 255, 255, 0.85);
  }
`;

type Props = {
  title: string;
  message?: string;
  setNotificationState: ({
    title,
    message,
  }: {
    title: "";
    message: "";
  }) => void;
};

const Notification = ({ title, message, setNotificationState }: Props) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const [hide, setHide] = useState(false);

  useEffect(() => {
    if (!title) return;

    setHide(false);

    timeoutRef.current = setTimeout(() => {
      setHide(true);
      setNotificationState({ title: "", message: "" });
    }, 2000);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [title]);

  if (!title) return null;

  return (
    <Layout>
      <Container
        animate={{
          y: hide ? -40 : 0,
          opacity: hide ? 0 : 1,
        }}
        initial={{ y: -40, opacity: 0 }}
        transition={defaultTransitionConfig}
      >
        <p>{title}</p>

        <span>{message}</span>
      </Container>
    </Layout>
  );
};

export { Notification };
